<template>
	<b-modal ref="modal" title="Edit item" :busy="loading>0">
		<b-form @submit.stop.prevent="save(); return false" id="categoryEditForm">
			<b-form-group label="Category name">
				<b-form-input v-model="curCategory.name" placeholder="Category name" required></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="categoryEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: 'CategoryEditModal',
	data() { return {
		services: [],
		id: null,
		curCategory: {settings: {}},
		loading: 0,
		error: null
	}},
	methods: {
		load(promise) {
			this.loading++;
			promise.catch(err => {
				this.error = err&&err.error||err.toString();
			}).finally(() => {
				this.loading--;
			});
			return promise;
		},
		show(id) {
			this.error = null;
			if(id) {
				this.$set(this, 'id', id);
				this.load(this.$api.get(`category/${id}`)).then(category => {
					category.password = '';
					this.curCategory = category
				});
			} else {
				this.$set(this, 'id', null);
				this.curCategory = {settings:{}};
			}

			this.$refs.modal.show();
		},
		save() {
			let data = {
				name: this.curCategory.name,
				password: this.curCategory.password,
				email: this.curCategory.email,
				restreaming_service_id: this.curCategory.restreaming_service_id,
			};
			if(this.id) {
				this.load(this.$api.patch(`category/${this.id}`, data)).then(() => {
					this.$refs.modal.hide();
					this.$bvToast.toast('Successfully saved category', { title: 'Success', variant: 'success', solid: true });
					this.$emit('saved');
				});
			} else {
				this.load(this.$api.post(`category`, data).then(() => {
					this.$refs.modal.hide();
					this.$bvToast.toast('Successfully created category', { title: 'Success', variant: 'success', solid: true });
					this.$emit('saved');
				}))
			}
		},
	}
};
</script>
